import React, { useState } from "react";
import ApiData from "../../api/ApiData";
import { observer } from "mobx-react-lite";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";
import { GenerationLicense } from "../licensing/GenerationLicense";
import { LicenseCommentsDrawer } from "../licensing/LicenseCommentsDrawer";
import RolesState from "../../api/RolesState";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import { DashCard } from "../UI/DashCard";

export const ComponentLicensingCardCompamy = observer(() => {
  const [genOpen, setGenOpen] = useState(false);
  const [commentsOpen, setCommentsOpen] = useState(false);
  const [inlineCount, setInlineCount] = useState(1);
  const [inlineLite, setInlineLite] = useState(false);
  const [genPrefill, setGenPrefill] = useState({
    count: 1,
    liteVersion: false,
  });

  const openGeneration = () => {
    const count = Math.max(1, Number(inlineCount) || 1);
    setGenPrefill({ count, liteVersion: inlineLite });
    setCommentsOpen(false);
    setGenOpen(true);
  };

  const openComments = () => {
    setGenOpen(false);
    setCommentsOpen(true);
  };

  const licensingInfo = ApiData.company.licensing_info;
  const companyId = ApiData.company.company?.id;
  const totalLicenses =
    licensingInfo !== null
      ? (licensingInfo.count_activ || 0) + (licensingInfo.count_free || 0)
      : 0;

  const commentsButton = (
    <BtnOutlineV4
      className="sub-status-comment-btn"
      text="Информация"
      onClick={openComments}
    />
  );

  return (
    <DashCard
      className="dash-card-subscription"
      title="Лицензии на оборудование"
    >
      {licensingInfo !== null ? (
        <div className="metrics-chips licensing_card_block">
          <div className="chip chip-total">
            <div className="chip-val">{totalLicenses}</div>
            <div className="chip-lbl">Всего</div>
          </div>
          <div className="chip chip-active">
            <div className="chip-val">{licensingInfo.count_activ || 0}</div>
            <div className="chip-lbl">Активно</div>
          </div>
          <div className="chip chip-free">
            <div className="chip-val">{licensingInfo.count_free || 0}</div>
            <div className="chip-lbl">Свободно</div>
          </div>
        </div>
      ) : (
        <ContainerSubTitleGrey
          style={{ fontSize: "25px", maxWidth: "290px" }}
          text="У данного клиента отстутствуют лицензии"
        />
      )}

      {RolesState.post_generate ? (
        <div className="license-gen-form">
          <select
            className="form-control"
            aria-label="Версия лицензии"
          >
            <option value="PRO">PRO</option>
          </select>
          <input
            className="form-control"
            type="number"
            min={1}
            value={inlineCount}
            onChange={(e) => {
              const val = e.target.value;
              if (val === "" || Number(val) < 1) {
                setInlineCount(1);
                return;
              }
              setInlineCount(Number(val));
            }}
            aria-label="Количество лицензий"
          />
          <BtnPrimaryv4 onClick={openGeneration} text="Сгенерировать" />
          {commentsButton}
        </div>
      ) : null}

      {licensingInfo !== null && !RolesState.post_generate ? (
        <div className="license-comments-actions">{commentsButton}</div>
      ) : null}

      <GenerationLicense
        open={genOpen}
        onClose={() => setGenOpen(false)}
        prefill={genPrefill}
      />

      <LicenseCommentsDrawer
        open={commentsOpen}
        onClose={() => setCommentsOpen(false)}
        companyId={companyId}
      />
    </DashCard>
  );
});
